import { useEffect, useState } from "react";
import { X, Award, ArrowRight } from "lucide-react";
import HeroesModal from "./HeroesModal";

const DISMISS_KEY = "heroes-bubble-dismissed-v1";

export default function HeroesBubble() {
    const [visible, setVisible] = useState(false);
    const [collapsed, setCollapsed] = useState(true);
    const [modalOpen, setModalOpen] = useState(false);

    // Show bubble expanded after 1.5s, then collapse to tab after 10s
    useEffect(() => {
        if (localStorage.getItem(DISMISS_KEY) === "collapsed") {
            setVisible(true);
            setCollapsed(true);
            return;
        }
        const t1 = setTimeout(() => {
            setVisible(true);
            setCollapsed(false);
        }, 1500);
        const t2 = setTimeout(() => {
            setCollapsed(true);
            try {
                localStorage.setItem(DISMISS_KEY, "collapsed");
            } catch (_) {
                // ignore
            }
        }, 11500);
        return () => {
            clearTimeout(t1);
            clearTimeout(t2);
        };
    }, []);

    if (!visible) return null;

    if (collapsed) {
        return (
            <button
                type="button"
                onClick={() => setCollapsed(false)}
                data-testid="heroes-tab"
                aria-label="Open Heroes Discount details"
                className="fixed bottom-4 left-4 z-40 inline-flex items-center gap-2 rounded-full border border-[color:var(--brand-gold)]/50 bg-[color:var(--brand-navy)] px-4 py-3 text-sm font-bold text-white shadow-lg transition hover:-translate-y-0.5 focus:outline-none focus:ring-2 focus:ring-[color:var(--brand-gold)]"
            >
                <Award className="h-5 w-5 text-[color:var(--brand-gold)]" />
                <span>Heroes Discount</span>
            </button>
        );
    }

    return (
        <>
            <div
                role="dialog"
                aria-label="Heroes Discount notification"
                data-testid="heroes-bubble"
                className="fixed bottom-4 left-4 right-4 z-40 max-w-sm rounded-2xl border-2 border-[color:var(--brand-gold)] bg-white p-5 shadow-2xl sm:right-auto sm:w-96"
            >
                <button
                    type="button"
                    onClick={() => {
                        setCollapsed(true);
                        try {
                            localStorage.setItem(DISMISS_KEY, "collapsed");
                        } catch (_) {
                            // ignore
                        }
                    }}
                    data-testid="heroes-bubble-close"
                    aria-label="Close Heroes Discount notification"
                    className="absolute right-2 top-2 grid h-9 w-9 place-items-center rounded-full text-slate-500 hover:bg-slate-100 focus:outline-none focus:ring-2 focus:ring-[color:var(--brand-navy)]"
                >
                    <X className="h-5 w-5" />
                </button>
                <div className="flex items-start gap-3 pr-6">
                    <span className="grid h-11 w-11 shrink-0 place-items-center rounded-full bg-[color:var(--brand-navy)] text-[color:var(--brand-gold)]">
                        <Award className="h-6 w-6" />
                    </span>
                    <div>
                        <div className="text-[11px] font-bold uppercase tracking-widest text-[color:var(--brand-green-2)]">
                            Heroes Discount
                        </div>
                        <p className="mt-1 text-base font-medium leading-snug text-[color:var(--brand-navy)]">
                            Veterans, active-duty military, police,
                            firefighters, EMTs, and paramedics receive{" "}
                            <strong>$20 off</strong> their rental.
                        </p>
                    </div>
                </div>
                <button
                    type="button"
                    onClick={() => setModalOpen(true)}
                    data-testid="heroes-bubble-verify"
                    className="hero-cta pill-btn mt-4 inline-flex w-full items-center justify-center gap-2 text-base text-white focus:outline-none focus:ring-2 focus:ring-[color:var(--brand-navy)]"
                >
                    Verify Before Checkout
                    <ArrowRight className="h-4 w-4" />
                </button>
            </div>
            {modalOpen && (
                <HeroesModal onClose={() => setModalOpen(false)} />
            )}
        </>
    );
}
